export default {"src":"/uk/_next/static/media/accountIconYellow.de63163e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};